import axios from 'axios';
import { useEffect, useState } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { FaEdit, FaSave } from 'react-icons/fa';
import { useLocation, useNavigate } from 'react-router-dom';
import CreatableSelect from 'react-select/creatable';
import { toast, ToastContainer } from 'react-toastify';
import DashboardLayout from './DashboardLayout ';
import JobTypeOptions from './JobTypeOptions';
import LocationPicker from './LocationPicker';
const UpdateEvergreenJob = () => {
    const BASE_API_URL = process.env.REACT_APP_API_URL;
    const location = useLocation();
    const { userEmail, userName, jobId, currentPage, currentPageSize } = location.state || {};
    const navigate = useNavigate();
    const [editableJobDetails, setEditableJobDetails] = useState(false);
    const [formData, setFormData] = useState({
        jobTitle: '',
        jobType: '',
        location: '',
        salary: '',
        postingDate: '',
        jobsummary: '',
        skills: [],
    });
    const [isSaved, setIsSaved] = useState(false); // Track whether the details are saved
    const userFromLocalStorage = JSON.parse(localStorage.getItem('user'));
    const companyName = userFromLocalStorage?.companyName;
    const [selectedLocs, setSelectedLocs] = useState([]);
    const handleBack = () => {
        // navigate('/hr-dashboard/evergreen-jobs', { state: { userEmail, userName, jobId, currentPage, currentPageSize } });
        navigate(-1)
    };

    useEffect(() => {
        if (jobId) {
            fetchJobDetails(jobId);
        }
    }, [jobId]);

    const fetchJobDetails = async (id) => {
        try {
            const response = await axios.get(`${BASE_API_URL}/getJob`, {
                params: { jobId: id },
            });

            const jobData = response.data;

            setFormData({
                ...jobData,
                skills: Array.isArray(jobData.skills)
                    ? jobData.skills
                    : jobData.skills
                        ? jobData.skills.split(',').map(skill => skill.trim())
                        : [],
            });

            setSelectedLocs(
                jobData.location
                    ? jobData.location.split(',').map(loc => loc.trim())
                    : []
            );
        } catch (error) {
            console.error("Failed to fetch job details", error);
        }
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleEditJobDetails = () => {
        setEditableJobDetails(true);
    };

    const handleSaveJobDetails = () => {
        setEditableJobDetails(false);
        setIsSaved(true); // Mark the details as saved
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!isSaved) {
            alert('Please save the changes before posting.');
            return;
        }
        const submissionData = {
            ...formData,
            skills: formData.skills.join(', '), // Convert array to comma-separated string
        };
        try {
            await axios.put(`${BASE_API_URL}/updateJob`, submissionData, {
                params: { jobId: jobId },
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            toast.success('Job details updated successfully.');
            // navigate('/hr-dashboard/evergreen-jobs', { state: { userName, userEmail, currentPage, currentPageSize } });
        } catch (error) {
        }
    };
    const handleLocationChange = (locs, country) => {
        setSelectedLocs(locs);
        setFormData(f => {
            const updatedData = {
                ...f,
                location: locs.join(', '),
            };

            if (country) {
                updatedData.countryCode = country;
            } else {
                delete updatedData.countryCode; // if you want to remove it
            }

            return updatedData;
        });

    };

    return (
        <DashboardLayout>
            <div className="main-content">
                <Card style={{ marginTop: '10px', width: '100%' }}>
                    <Card.Header>
                        <Card.Title className="mb-0" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <h3 style={{ fontSize: '25px', margin: 0 }}>Update Evergreen Job</h3>
                            <p style={{ margin: 0 }}>
                                (Edit job details to ensure accurate information and attract the right candidates)
                            </p>
                        </Card.Title>
                    </Card.Header>

                    <Form onSubmit={handleSubmit}>
                        <Card.Body>
                            <Row style={{ marginBottom: '24px' }}>
                                <Col md={6}>
                                    <Form.Group controlId="jobTitle">
                                        <Form.Label htmlFor="jobTitle" className='required-label'>Job Title:</Form.Label>
                                        <Form.Control
                                            type="text"
                                            id="jobTitle"
                                            name="jobTitle"
                                            value={formData.jobTitle}
                                            onChange={handleChange}
                                            disabled={!editableJobDetails}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className='jobType'>
                                        <Form.Label htmlFor="jobType" className="required-label">Job Type:</Form.Label>
                                        {editableJobDetails ? (
                                            <Form.Select
                                                id="jobType"
                                                name="jobType"
                                                value={formData.jobType}
                                                onChange={handleChange}
                                            >
                                                {JobTypeOptions.map((type, index) => (
                                                    <option key={index} value={type}>{type}</option>
                                                ))}
                                            </Form.Select>
                                        ) : (
                                            <Form.Control
                                                type="text"
                                                id="jobType"
                                                name="jobType"
                                                value={formData.jobType}
                                                readOnly
                                                disabled
                                            />
                                        )}
                                    </Form.Group>

                                </Col>
                            </Row>

                            <Row style={{ marginBottom: '24px' }}>
                                <Col md={6}>
                                    <Form.Group className='postingDate'>
                                        <Form.Label htmlFor="postingDate" className='required-label'>Posting Date:</Form.Label>
                                        <Form.Control
                                            type="date"
                                            id="postingDate"
                                            name="postingDate"
                                            value={formData.postingDate}
                                            onChange={handleChange}
                                            disabled={!editableJobDetails}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className='skills'>
                                        <Form.Label htmlFor="skills" className="required-label">Skills:</Form.Label>
                                        <CreatableSelect
                                            id="skills"
                                            isMulti
                                            value={Array.isArray(formData.skills)
                                                ? formData.skills.map(skill => ({ label: skill, value: skill }))
                                                : []
                                            }
                                            onChange={(selectedOptions) =>
                                                setFormData({
                                                    ...formData,
                                                    skills: selectedOptions.map(opt => opt.value),
                                                })
                                            }
                                            isDisabled={!editableJobDetails}
                                            placeholder="Eg: Java, Python, React"
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row style={{ marginBottom: '24px' }}>
                                <Col md={6}>
                                    <Form.Group className='salary'>
                                        <Form.Label htmlFor="salary" className='required-label'>Salary:</Form.Label>
                                        <Form.Control
                                            type="text"
                                            id="salary"
                                            name="salary"
                                            value={formData.salary}
                                            onChange={handleChange}
                                            disabled={!editableJobDetails}
                                        />
                                    </Form.Group>
                                </Col>
                                {/* <Col md={6}>
                                    <Form.Group className='location'>
                                        <Form.Label htmlFor="location" className='required-label'>Location:</Form.Label>
                                        <Form.Control
                                            type="text"
                                            id="location"
                                            name="location"
                                            value={formData.location}
                                            onChange={handleChange}
                                            disabled={!editableJobDetails}
                                        />
                                    </Form.Group>
                                </Col> */}
                                <Col md={6}>
                                    {!editableJobDetails ? (
                                        <Form.Group className="location">
                                            <Form.Label htmlFor="location" className="required-label">Location:</Form.Label>
                                            {/* Show text input only when NOT editing */}
                                            <Form.Control
                                                type="text"
                                                id="location"
                                                name="location"
                                                value={formData.location}
                                                disabled
                                            />
                                        </Form.Group>
                                    ) : (
                                        // When editing, show LocationPicker inside the same Col
                                        <LocationPicker
                                            companyName={companyName}
                                            apiUrl={BASE_API_URL}
                                            initialCountry="IN"
                                            initialSelection={selectedLocs}
                                            onChange={handleLocationChange}
                                        />
                                    )}
                                </Col>
                            </Row>
                            <Form.Group controlId="jobsummary">
                                <Form.Label htmlFor="jobsummary" className='required-label'>Job summary:</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    id="jobsummary"
                                    name="jobsummary"
                                    value={formData.jobsummary}
                                    onChange={handleChange}
                                    disabled={!editableJobDetails}
                                    style={{ minHeight: '150px' }}
                                />
                            </Form.Group>
                        </Card.Body>
                        <Card.Footer>
                            <div className='job-save-edit-buttons'>
                                {editableJobDetails ? (
                                    <Button variant="primary" type="button" onClick={handleSaveJobDetails}><FaSave /> Save</Button>
                                ) : (
                                    <Button variant="info" type="button" onClick={handleEditJobDetails}><FaEdit /> Edit</Button>
                                )}
                                <Button variant="success" type="submit" disabled={!isSaved}>Post</Button>
                                <Button variant='primary' onClick={handleBack}>Back</Button>
                            </div>
                        </Card.Footer>
                    </Form>
                </Card>
            </div>
            <ToastContainer />
        </DashboardLayout>
    );
};

export default UpdateEvergreenJob;
